export const CONFIG_LIST_KEY = 'ai-alert-config-list';
export const CONFIG_LOG_KEY = 'ai-alert-config-log';
